export { default } from "./EmailCapture";
